export default {
  extensionID: 'ookcfeohfcfmpapmafpljepfljnlkdcn',
  relishCookieKey: 'relishToken-v2',
};
